import { IPath } from "../ahamove/UrlRequestParam"

export enum PathsEventEnum {
  REMOVE = 'remove',
  CHANGE = 'change',
  ITEMS = 'items'
}

export interface IPaths {
  data_source: IPath[]
  updatePath(event: any, type: PathsEventEnum, index?: number): void
}